import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { ArgInputByType } from "./arg-input-by-type.js";
import { rendersAsInputObject } from "./arg-input-by-type.js";
const ArgInput = (t0) => {
  const $ = c(9);
  const {
    arg,
    value,
    onChange,
    isVariable: t1,
    variableName,
    onPromote,
    onDemote
  } = t0;
  const isVariable = t1 === void 0 ? false : t1;
  let t2;
  if ($[0] !== arg.name || $[1] !== arg.type || $[2] !== isVariable || $[3] !== onChange || $[4] !== onDemote || $[5] !== onPromote || $[6] !== value || $[7] !== variableName) {
    t2 = /* @__PURE__ */ jsx(ArgInputByType, { type: arg.type, name: arg.name, value, onChange, isVariable, variableName, onPromote, onDemote });
    $[0] = arg.name;
    $[1] = arg.type;
    $[2] = isVariable;
    $[3] = onChange;
    $[4] = onDemote;
    $[5] = onPromote;
    $[6] = value;
    $[7] = variableName;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
};
export {
  ArgInput,
  rendersAsInputObject
};
//# sourceMappingURL=index.js.map
